import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export default function ProtectedRoute({ children, adminOnly = false }) {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAuthorized(false);
        setLoading(false);
        return;
      }

      // Agar sirf login check karna hai (jaise Profile page ke liye)
      if (!adminOnly) {
        setIsAuthorized(true);
        setLoading(false);
        return;
      }

      // Agar Admin check karna hai (jaise Admin Dashboard ke liye)
      try {
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
        
        if (userDoc.exists() && userDoc.data().role === 'admin') {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } catch (error) {
        console.error("Error checking role:", error);
        setIsAuthorized(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [auth, adminOnly]);

  if (loading) {
    return <div className="flex h-screen items-center justify-center font-bold text-gray-600">Loading security check...</div>;
  }

  // Agar authorized nahi hai toh login page par bhej dein
  if (!isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  return children;
}